export enum IkeSortOrder {
	ASC = 1,
	DESC = -1,
}

export function byKey<T, K extends keyof T>(data: T[], key: K | K[], sortOrder: IkeSortOrder) {
	let keys: K[];
	if (!Array.isArray(key)) {
		keys = [key];
	} else {
		keys = key;
	}

	function compare(keyIndex: number, a: T, b: T) {
		const firstKey = keys[keyIndex];
		const keyA = a[firstKey];
		const keyB = b[firstKey];
		if (keyA === keyB) {
			if (keys.length - 1 > keyIndex) {
				return compare(keyIndex + 1, a, b);
			}
			return 0;
		}

		if (keyA == null) return 1;
		if (keyB == null) return -1;

		if (keyA > keyB) {
			return 1 * sortOrder;
		}
		return -1 * sortOrder;
	}

	return data.sort(compare.bind(null, 0));
}

export const IkeSort = {
	DESC: IkeSortOrder.DESC,
	ASC: IkeSortOrder.ASC,
	Order: IkeSortOrder,
	byKey,
};
